import { ref } from 'vue'
import {
  chatgptTalkStream,
  streamSpeaker,
  getNlpGetQaRetrivalInfo
} from '@/api/chat/index'
import 'element-plus/dist/index.css'
import { useStore } from 'vuex'
import bus from '@/utils/mitt.js'

import roleHooks from '@/hooks/roleHooks'
import userHooks from '@/hooks/userHooks'

const dellText = (text: any) => {
  // const text = '1. how are you? 2. I like 3.14m swimming. This is a sentence. Another sentence? Yes! And one more... 这是中文句子。这是另一句中文句子？是的！还有一句中文句子……' // Sample text
  const regexEnglish =
    /(?<!\w\.\w\.)(?<!\d\.\d\.)(?<![A-Z][a-z]\.)(?<!Mr\.)(?<!Ms\.)(?<!Mrs\.)(?<!Dr\.)(?<!Prof\.)(?<=\.|\?|\!)\s/
  const regexChinese = /(?<=[。！？])/

  const sentences = text
    .split(regexEnglish)
    .map((sentence: any) => {
      if (regexChinese.test(sentence)) {
        return sentence.split(regexChinese)
      } else {
        return sentence
      }
    })
    .flat()
  const mergedSentences = []
  for (let i = 0; i < sentences.length; i++) {
    if (
      mergedSentences.length > 0 &&
      mergedSentences[mergedSentences.length - 1].length < 10
    ) {
      mergedSentences[mergedSentences.length - 1] += ' ' + sentences[i]
    } else {
      mergedSentences.push(sentences[i])
    }
  }
  // console.log(mergedSentences, 'mergedSentences')
  return mergedSentences
}
const sleep = (delay: any) =>
  new Promise((resolve) => setTimeout(resolve, delay))

export default (audioBuffer: any) => {
  const word = ref('')
  const store = useStore()
  const { curDigitalInfo, showAvatar } = roleHooks()
  const { uuid } = userHooks()
  let list: any = []
  let isDell = ref(false)
  let wordPre = 0
  let arrIndex = 0
  const dellTextToAudio = async () => {
    while (isDell.value) {
      const curInfo = list.shift()
      if (!curInfo) {
        console.log('sleep')
        await sleep(40)
        continue
      }
      const { value, done } = curInfo
      if (done) isDell.value = false
      const curText = value.slice(wordPre)
      const regexp = new RegExp(/[，。！？]|([,.!?]\s)/, 'g')
      let lastIndex
      let match,
        lastPosition = -1
      while ((match = regexp.exec(curText)) !== null) {
        lastIndex = match.index
      }
      if (lastIndex) {
        wordPre += lastIndex + 1
        const text = curText.slice(0, lastIndex + 1)
        console.log(text, new Date().getTime() / 1000, '截取时间')
        await streamSpeaker(
          {
            speaker: store.state?.role?.curDigitalInfo?.magicAudioId,
            selectWord: text
          },
          (audio: any, doneAudio: any) => {
            console.log(text, new Date().getTime() / 1000, '音频流')
            audioBuffer(audio)
          }
        )
      }
      if (done && !lastIndex && curText && curText != '\n') {
        console.log(curText, new Date().getTime() / 1000, '截取时间 done')
        await streamSpeaker(
          {
            speaker: store.state?.role?.curDigitalInfo?.magicAudioId,
            selectWord: curText
          },
          (audio: any, doneAudio: any) => {
            console.log(curText, new Date().getTime() / 1000, '音频流 done')
            audioBuffer(audio)
          }
        )
      }
      if (done) {
        await new Promise(() => {
          const uintLength = wordPre <= 1 ? 16 * 300 * 4 : 16 * 300 * 2
          console.log('ws.send quietAudio !', new Date().getTime() / 1000)
          const u8arr = new Uint8Array(uintLength)
          audioBuffer(u8arr)
          bus.emit('sendStatus', 'end')
        })
      }
    }
  }
  // const dellTextToAudio = async () => {
  //   while (isDell) {
  //     const curInfo = list.shift()
  //     if (!curInfo) {
  //       console.log('sleep')
  //       await sleep(40)
  //       continue
  //     }
  //     const { value, done } = curInfo
  //     if (done) isDell = false
  //     const arrText = dellText(value)
  //     if (arrText.length <= 1 && done) {
  //       arrIndex = 0
  //       arrText[arrIndex] &&
  //         arrText[arrIndex] != '\n' &&
  //         (await streamSpeaker(
  //           {
  //             speaker: store.state?.role?.curDigitalInfo?.magicAudioId,
  //             selectWord: arrText[arrIndex]
  //           },
  //           (audio: any, doneAudio: any) => {
  //             audioBuffer(audio)
  //           }
  //         ))
  //       await new Promise(() => {
  //         const uintLength = arrIndex <= 1 ? 16 * 300 * 4 : 16 * 300 * 2
  //         console.log('ws.send quietAudio !', new Date().getTime() / 1000)
  //         const u8arr = new Uint8Array(uintLength)
  //         audioBuffer(u8arr)
  //         bus.emit('sendStatus', 'end')
  //       })
  //       await new Promise(() => {
  //         bus.emit('sendStatus', 'end')
  //       })
  //       return
  //     }
  //     if (arrText.length > arrIndex + 1) {
  //       arrText[arrIndex] &&
  //         (await streamSpeaker(
  //           {
  //             speaker: store.state?.role?.curDigitalInfo?.magicAudioId,
  //             selectWord: arrText[arrIndex]
  //           },
  //           (audio: any, doneAudio: any) => {
  //             audioBuffer(audio)
  //           }
  //         ))
  //       arrIndex++
  //     }
  //     if (done) {
  //       arrText[arrIndex] &&
  //         arrText[arrIndex] != '\n' &&
  //         (await streamSpeaker(
  //           {
  //             speaker: store.state?.role?.curDigitalInfo?.magicAudioId,
  //             selectWord: arrText[arrIndex]
  //           },
  //           (audio: any, doneAudio: any) => {
  //             audioBuffer(audio)
  //           }
  //         ))
  //       await new Promise(() => {
  //         const uintLength = arrIndex <= 1 ? 16 * 300 * 4 : 16 * 300 * 2
  //         console.log('ws.send quietAudio !', new Date().getTime() / 1000)
  //         const u8arr = new Uint8Array(uintLength)
  //         audioBuffer(u8arr)
  //         bus.emit('sendStatus', 'end')
  //       })
  //       await new Promise(() => {
  //         bus.emit('sendStatus', 'end')
  //       })
  //     }
  //   }
  // }
  const chatEvent = (cb?: any) => {
    const cid: any = ~~new Date().getTime().toString().slice(-9)
    const paramsSord = word.value
    let pageData: any = ''
    word.value = ''
    wordPre = 0
    arrIndex = 0
    list = []
    isDell.value = true
    showAvatar.value && dellTextToAudio()
    showAvatar.value && bus.emit('sendStatus', 'start')
    chatgptTalkStream(
      {
        roleId: store.state.role.curSelectRoleInfo.id,
        fileId: store.state.role.curSelectRoleInfo.txtId,
        question: paramsSord,
        session: uuid.value
      },
      async (value: any, done: any) => {
        list.push({ value, done })
        return
      },
      (value: any, done: any) => {
        cb && cb(value + (done ? ` ${pageData}` : ''), cid, done)
      }
    )
    getNlpGetQaRetrivalInfo({
      roleId: store.state.role.curSelectRoleInfo.id,
      fileId: store.state.role.curSelectRoleInfo.txtId,
      question: paramsSord,
      session: uuid.value
    }).then((res: any) => {
      pageData = res
        ? `【参考${res?.name ? `《${res?.name}》` : ''}第${res?.pageNumber}页】`
        : ''
    })
  }
  return {
    chatEvent,
    word,
    isDell
  }
}
